import { Contact } from '@lockton-apps/shared/interfaces';
import { MockedClientDefaultId } from './clients.mock';

export const MOCKED_CLIENT_CONTACTS_DEFAULT: Record<number, Contact[]> = {
  // LSOS
  [MockedClientDefaultId.LsosDefault]: [],

  // NORWAY
  [MockedClientDefaultId.NorwayDefaultCorporateHealthBusiness]: [],
  [MockedClientDefaultId.NorwayDefaultCorporateHealthPrivate]: [],
};
